//CRN_20260508 - Riskline City Reports service (PUSH side - reads from SureSim backend)
//CRN_20260513 - https://riskline.readme.io/reference/apis-overview

import { catchError, Observable, of, throwError } from 'rxjs';
import { CityReportDTO } from '../../models/system/riskline/riskline-city-report.dto';
import { eSimApiPaths } from '../../consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../utelize/general/exceptions-service';
import { HttpClientService } from '../utelize/general/http-client-service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RisklineCityReportsService {

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getAllCityReports(): Observable<CityReportDTO[]> {
    try {
      return this.httpClientService
             .get<CityReportDTO[]>(environment.eSimApi +
                                   eSimApiPaths.RiskIntelligence + '/' +
                                   eSimApiPaths.RiskIntelligenceCityReports)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklineCityReportsService.getAllCityReports() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of([]);
    }
  }

  public getCityReport(iataCode: string): Observable<CityReportDTO> {
    try {
      if (!iataCode || iataCode.trim()=='')
        throw new Error('RisklineCityReportsService.getCityReport() - iataCode is required');

      return this.httpClientService
                 .get<CityReportDTO>(environment.eSimApi +
                                     eSimApiPaths.RiskIntelligence + '/' +
                                     eSimApiPaths.RiskIntelligenceCityReports + '/' +
                                     iataCode)
                 .pipe(
                   catchError((error) => {
                     return throwError(() => new Error('RisklineCityReportsService.getCityReport() - ' + this.exceptionsService.formatHttpError(error)));
                   })
                 );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
